import React, { useState, useEffect } from "react";
import LabelInput from "../../components/common/forms/Labelinput";
import Modal from "../../components/common/forms/modal";
import { API_CONFIG, getHeaders, refreshAccessToken } from "../../config/api";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import WarningModal from "../common/ui/warningmodel";


export default function AddSection({ isOpen, onClose, editData, onSectionAdded }) {
  const [isProcessingService, setIsProcessingService] = useState(false);
  const [formData, setFormData] = useState({
    sectionName: "",
    sectionDescription: "",
  });
  const [errors, setErrors] = useState({});
  const { logout } = useAuth();
  const [warningVisible, setWarningVisible] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");


  // ✅ Prefill form when editing OR reset when adding new
  useEffect(() => {
    if (editData) {
      setFormData({
        sectionName: editData.sectionName || "",
        sectionDescription: editData.sectionDescription || "",
      });
    } else if (isOpen) {
      setFormData({ sectionName: "", sectionDescription: "" });
      setErrors({});
    }
  }, [editData, isOpen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessingService(true);
    setErrors({});

    try {
      const payload = {
        section_name: formData.sectionName.trim(),
        section_desc: formData.sectionDescription.trim(),
      };

      let response, result;

      // Helper function to call the correct API
      const callApi = async () => {
        if (editData) {
          // 🟡 Edit Section API
          return await fetch(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SECTIONS.UPDATE_SECTION(editData.id)}`,
            {
              method: "PUT",
              headers: getHeaders(true),
              body: JSON.stringify(payload),
            }
          );
        } else {
          // 🟢 Create Section API
          return await fetch(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SECTIONS.CREATE}`,
            {
              method: "POST",
              headers: getHeaders(true),
              body: JSON.stringify(payload),
            }
          );
        }
      };

      // Initial API call
      response = await callApi();

      // -------------------------
      // 🔥 Handle 401 token expired
      // -------------------------
      if (response.status === 401) {
        console.warn("Access token expired. Attempting refresh...");
        const newToken = await refreshAccessToken();

        if (newToken) {
          // Retry the same API call with new token
          response = await callApi();
        } else {
          console.error("Refresh token failed. Logging out...");
          logout(); // redirect user
          return;
        }
      }

      result = await response.json();
      console.log("Section API result:", result);

      if (response.ok && (result.status === 200 || result.status === 201)) {
        toast.success(
          result.message ||
          (editData ? "Section updated successfully!" : "Section added successfully!")
        );

        setFormData({ sectionName: "", sectionDescription: "" });
        setErrors({});

        if (onSectionAdded) await onSectionAdded();
        onClose();
      } else {
        setWarningMessage(result.message || "Failed to save section");
        setWarningVisible(true);
        setErrors({ api: result.message || "Failed to save section" });
      }
    } catch (error) {
      console.error("Error adding/updating section:", error);
      setWarningMessage("Something went wrong");
      setWarningVisible(true);
      setErrors({ api: "Something went wrong" });
    } finally {
      setIsProcessingService(false);
    }
  };


  if (!isOpen) return null;

  return (
    <>
      <Modal
        isOpen={isOpen}
        title={editData ? "Edit Section" : "Add New Section"}
        onClose={onClose}
        onSubmit={handleSubmit}
        isProcessing={isProcessingService}
        submitText={isProcessingService ? editData ? "Updating..." : "Adding..." : editData ? "Update Section" : "Add Section"}
      >
        <LabelInput
          label="Section Name"
          type="text"
          name="sectionName"
          value={formData.sectionName}
          onChange={handleChange}
          placeholder="Enter Section Name"
          required
          error={errors.sectionName}
        />

        <LabelInput
          label="Section Description"
          type="text"
          name="sectionDescription"
          value={formData.sectionDescription}
          onChange={handleChange}
          placeholder="Enter Section Description"
          required
          error={errors.sectionDescription}
        />
      </Modal>
      {warningVisible && (
        <WarningModal
          message={warningMessage}
          onClose={() => setWarningVisible(false)}
        />
      )}

    </>
  );
}
